var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var _a;
import React from "react";
import styled from "styled-components";
import { SizeEnum, TagColorEnum } from "../../enums";
var IndicatorSize = (_a = {},
    _a[SizeEnum.tiny] = {
        size: .5
    },
    _a[SizeEnum.small] = {
        size: .6
    },
    _a[SizeEnum.medium] = {
        size: .75
    },
    _a[SizeEnum.large] = {
        size: .9
    },
    _a[SizeEnum.giant] = {
        size: 1
    },
    _a);
var IndicatorContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
    return "\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      color: ".concat(props.theme.colorContent(), ";\n      font-size: ").concat(IndicatorSize[props.size].size, "rem;\n    ");
});
var StyledIndicator = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
    return "\n      height: ".concat(IndicatorSize[props.size].size, "rem;\n      width: ").concat(IndicatorSize[props.size].size, "rem;\n      border-radius: 50%;\n      margin-bottom: .3rem;\n      background-color: ").concat(props.active ? TagColorEnum.green : TagColorEnum.red, ";\n");
});
var Indicator = function (_a) {
    var label = _a.label, _b = _a.size, size = _b === void 0 ? SizeEnum.medium : _b, active = _a.active;
    return (React.createElement(IndicatorContainer, { size: size },
        React.createElement(StyledIndicator, { size: size, active: active }),
        label));
};
export default Indicator;
var templateObject_1, templateObject_2;
